module.exports = __webpack_public_path__ + "images/forms.81cf45a7.webp";